import { TOKEN_EXPIRED, UNAUTHENTICATED } from '@speeki/dictionary';

import { LoginWithMfaDocument } from '@graphql/generated/graphql';

import { useInitializeSession } from '@services/AuthService/useInitializeSession';

import { useMutation } from '@apollo/client';

export const useLoginMfa = () => {
    const [loginWithMfa, { error, reset }] = useMutation(LoginWithMfaDocument, {
        context: {
            notifyOnError: {
                exceptions: [UNAUTHENTICATED, TOKEN_EXPIRED],
            },
        },
        onError: () => {},
    });
    const { initializeSession } = useInitializeSession(loginWithMfa, true);

    return {
        cancelLogin: reset,
        handleLogin: initializeSession,
        loginError: error,
    };
};
